import { Component } from '@angular/core';

@Component({
  selector: 'usb-edit-search-modal',
  template: `
    <usb-popup [isLoading]="true" [popupClass]="'bg'">
      <div class="mb-3">
        <img class="fa-spin" width="40" height="40" src="../../../../assets/icons/SPINNER.svg" alt="Spinner" />
      </div>
      <h2 class="cancel-loader_title">Editar Busqueda</h2>
      <h3 class="cancel-loader_subtitle mb-2">de Alojamientos</h3>
      <p class="cancel-loader_text">Cargando Información <br /> Gracias por esperar</p>
    </usb-popup>
  `,
  styleUrls: ['./edit-search-modal.component.scss']
})
export class EditSearchModalComponent {}
